import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext'; // Adjust path if needed

const ManageSubscriptionButton = () => {
  const { session } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleManageSubscription = async () => {
    setIsLoading(true);
    setError(null);

    if (!session || !session.access_token) {
      setError('User not authenticated.');
      setIsLoading(false);
      return;
    }

    try {
      const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
      if (!supabaseUrl) {
        throw new Error('Supabase URL is not configured.');
      }

      const response = await fetch(
        `${supabaseUrl}/functions/v1/create-customer-portal-session`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${session.access_token}`,
            'Content-Type': 'application/json',
            // 'apikey': process.env.REACT_APP_SUPABASE_ANON_KEY, // Usually not needed when auth token is present
          },
          body: JSON.stringify({}), // Empty body is fine
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || `Request failed with status ${response.status}`);
      }

      if (data.portalUrl) {
        window.location.href = data.portalUrl; // Redirect to Stripe Customer Portal
      } else {
        throw new Error('Portal URL not received.');
      }

    } catch (err) {
      console.error('Error creating customer portal session:', err);
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <button 
        onClick={handleManageSubscription} 
        disabled={isLoading}
        style={{
          padding: '10px 20px',
          fontSize: '16px',
          color: 'white',
          backgroundColor: '#007bff',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          opacity: isLoading ? 0.7 : 1
        }}
      >
        {isLoading ? 'Loading Portal...' : 'Manage My Subscription'}
      </button>
      {error && <p style={{ color: 'red', marginTop: '10px' }}>Error: {error}</p>}
    </div>
  );
};

export default ManageSubscriptionButton;
